import { gantt } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveGanttRequestFailure(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.request.isFailure : false;
    },
    isRetrieveGanttRequestPending(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.request.isPending : false;
    },
    isRetrieveGanttRequestSuccess(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.request.isSuccessful : false;
    },
    getGantt(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.gantt : gantt;
    },
    canRetrieveGantt(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.canLoadMore : true;
    },
    getGanttPage(size, sort, zone, resources) {
      const resourceUuids =
        resources
          ?.map((r) => r.uuid)
          .sort()
          .join(",") || "";
      const req = getState().find((req) => {
        const reqResourceUuids =
          req.resources
            ?.map((r) => r.uuid)
            .sort()
            .join(",") || "";

        return (
          req.size === size &&
          req.sort === sort &&
          ((typeof req.zone === "undefined" && typeof zone === "undefined") ||
            req.zone?.uuid === zone?.uuid) &&
          resourceUuids === reqResourceUuids
        );
      });

      return req ? req.page : 0;
    },
  };
}

export { createSelector };
